<template>
  <div>
    <div class="search-con">
      <Button @click="showEditModal()" v-if="this.$getMenuAuthority('sys:model:save')" class="search-btn" type="primary"><Icon type="search"/>添加</Button>
    </div>
    <Modal v-model="editModalShow" @on-ok="saveInfo()" scrollable title="编辑">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" class="edit-win">
        <FormItem label="模板名" prop="name">
          <Input v-model="formValidate.name" placeholder="请输入模板名" style="width: 360px"></Input>
        </FormItem>
        <FormItem label="模板地址" prop="path">
          <Input v-model="formValidate.path" placeholder="请输入模板地址" style="width: 360px"></Input>
        </FormItem>
        <FormItem label="模板打印时长(年)" prop="plimit">
          <Input v-model="formValidate.plimit" placeholder="请输入模板打印时长" style="width: 360px"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
    </div>
  </div>
</template>

<script>
import { truncate, copyFile, constants } from 'fs';
export default {
  data () {
    return {
      editModalShow: false,  //编辑框
      formValidate: {
        name: '',         //模板名
        path: '',         //模板地址
        plimit: '',       //打印时常
      },
      ruleValidate: {
        name: [
          { required: true, message: '模板名不能为空', trigger: 'blur' }
        ],
        path: [
          { required: true, message: '模板地址不能为空', trigger: 'blur' }
        ],
      },
      showData: {           //列表容器
        pageNum: 1
      },
      columns1: [           //表头
        {title: '模板名称',key: 'name'},
        {title: '可打印年限', align: 'center', key: 'plimit',
          render: (h, params) => {
            return h('div', params.row.plimit+'年')
          }
        },
        {title: '状态', align: 'center', key: 'state',
          render: (h, params) => {
            return h('div', params.row.state==1?'禁用':'正常')
          }
        },
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'primary',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:model:disoren') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.enable(params.row.id,params.row.state)
                  }
                }
              }, params.row.state==1?'启用':'禁用'),
              h('Button', {
                props: {type: 'error',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:model:delete') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.deleteInfo(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      ]
    }
  },
  activated() {
    this.getList ()
  },
  mounted () {
    this.getList ()
  },
  methods: {
    chagepage (current) {
      this.showData.pageNum = current
      this.getList()
    },
    getList () {   //获取列表
      this.$Loading.start()
      this.$axios.get('/model/list/' + this.showData.pageNum)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    showEditModal() {
      this.formValidate = {
        name: '',         //模板名
        path: '',         //模板地址
        plimit: '',       //打印时常
      }
      this.editModalShow = true
    },
    enable(id,type) {
      type== 1?type =2:type=1
      this.$Loading.start()
      this.$axios.get('/model/disoren/'+id+'/' + type)
      .then(function (response) {
        if (response.data.success) {
          this.getList()
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    saveInfo() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$Loading.start()
          this.$axios.post('/model/save',this.formValidate)
          .then(function (response) {
              if (response.data.success) {
                this.formValidate = {
                  name: '',         //模板名
                  path: '',         //模板地址
                  plimit: '',       //打印时常
                },
                this.getList()
                this.$Message.success(response.data.errMsg)
                this.$Loading.finish()
              } else {
                this.$Message.error(response.data.errMsg)
                this.$Loading.error()
              }
          }.bind(this))
        }
      })
    },
    deleteInfo (id) {
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
            this.$Loading.start()
            this.$axios.get('/model/del/'+id)
            .then(function (response) {
                if (response.data.success) {
                  this.getList()
                  this.$Message.success(response.data.errMsg)
                  this.$Loading.finish()
                } else {
                  this.$Message.error(response.data.errMsg)
                  this.$Loading.error()
                }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/template/list.vue